import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { ToastBaseComponent, ToastData } from '../toast.type';

@Component({
  selector: 'red-error-toast',
  templateUrl: './error-toast.component.html',
  styleUrls: ['./error-toast.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorToastComponent implements ToastBaseComponent {
  public data: ToastData = inject(MAT_SNACK_BAR_DATA);

  constructor(public snackBarRef: MatSnackBarRef<ErrorToastComponent>) {}
}
